    function hideEmptyColumns(tableId) {
      const table = document.getElementById(tableId);
      const rows = table.rows;
      if (rows.length === 0) return;

      const colCount = rows[0].cells.length;
      const colsToHide = new Set();

      for (let col = 0; col < colCount; col++) {
        let isEmpty = true;

        for (let row = 1; row < rows.length; row++) {
          const cell = rows[row].cells[col];
          if (cell && cell.textContent.trim() !== "") {
            isEmpty = false;
            break;
          }
        }

        if (isEmpty) {
          colsToHide.add(col);
        }
      }

      colsToHide.forEach(col => {
        for (let row = 0; row < rows.length; row++) {
          rows[row].cells[col].classList.add('hidden');
        }
      });
    }

    document.addEventListener("DOMContentLoaded", () => hideEmptyColumns("myTable"));
